import { Box, CircularProgress } from "@mui/material";
import React from "react";
import { useCaptureLicensing } from "../../../hooks/Capture";
import CaptureLicensing from "../Licensing/CaptureLicensing";

interface LicensingTabProps {
  captureId: string;
  handleError: (error: any) => void;
  canEdit: boolean;
}

const LicensingTab: React.FC<LicensingTabProps> = ({ captureId, handleError, canEdit }) => {
  const { licensingData, isPending, createLicensing, updateLicensing } = useCaptureLicensing(captureId);

  if (isPending && licensingData === null) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <CaptureLicensing
      licensingData={licensingData}
      canEdit={canEdit}
      onCreate={async (values) => {
        await createLicensing(values).catch(handleError);
      }}
      onUpdate={async (id, values) => {
        await updateLicensing({ licensingId: id, values }).catch(handleError);
      }}
    />
  );
};

export default LicensingTab;
